import parentScope from '../types';

export const SCOPE = `${parentScope}.meta`;
export const FETCHING = `${SCOPE}/FETCHING`;
export const FETCHING_SUCCESS = `${SCOPE}/FETCHING_SUCCESS`;
export const FETCHING_FAILURE = `${SCOPE}/FETCHING_FAILURE`;
export const SET_METRICS = `${SCOPE}/SET_METRICS`;
